import { ReactComponent as ChevronLeft } from "./ChevronLeft.svg";
import { ReactComponent as ChevronRight } from "./ChevronRight.svg";
import SvgIcon from "../SvgIcon";
import { FunctionComponent } from "react";

interface IconChervonProps {
	direction: "left" | "right";
	id?: any;
	className?: string;
}

const IconChevron: FunctionComponent<IconChervonProps> = ({
	id,
	direction,
	className,
}) => {
	return (
		<SvgIcon
			id={id}
			svg={direction === "left" ? <ChevronLeft /> : <ChevronRight />}
			className={className}
		/>
	);
};

export default IconChevron;
